import { Route } from "react-router-dom";
import AppSections from "../utils/AppSections";
import ProtectedRoute from "./ProtectedRoute";
import StaticPages from "../ui/static_pages_admin/StaticPages";
import StaticPageAddEdit from "../ui/static_pages_admin/StaticPageAddEdit";
import StaticPageDetails from "../ui/static_pages_admin/StaticPageDetails";
import StaticPagesList from "../ui/static_pages_admin/StaticPagesList";

const StaticPagesRoutes = (
  <Route
    path={AppSections.STATIC_PAGES}
    element={
      <ProtectedRoute>
        <StaticPages />
      </ProtectedRoute>
    }
  >
    <Route path="/static-pages/" element={<StaticPagesList />} />
    <Route path="create" element={<StaticPageAddEdit />} />
    <Route path=":id/view" element={<StaticPageDetails />} />
    <Route path=":id/edit" element={<StaticPageAddEdit />} />
  </Route>
);

export default StaticPagesRoutes;
